import { useApolloClient } from "lib/apollo/client";
import { gql } from "graphql-tag";

export const deleteListBook = gql`
  mutation DeleteListBook($id: Int!) {
    deleteResponse: delete_list_book(id: $id) {
      id
      list {
        ...ListFragment
      }
    }
  }
`;

export const removeListBook = ({ id }) => {
  const client = useApolloClient();
  return client.mutate({
    mutation: deleteListBook,
    variables: {
      id,
    },
  });
};
